import * as Styled from "./article-list.style";
import { UseArticleTableData } from "src/ui/data/use-article-table";
import { useScrollEdges } from "src/ui/hooks";

export const ArticleList = () => {
	const { header, articles } = UseArticleTableData();
	const { ref, isScrollAtTop, isScrollAtBottom } =
		useScrollEdges<HTMLDivElement>();

	return (
		<Styled.ArticleList
			ref={ref}
			scrollAtTop={isScrollAtTop}
			scrollAtBottom={isScrollAtBottom}
		>
			{articles.map((article) => {
				const { id, contentArray } = article;
				return (
					<Styled.Article key={id}>
						{contentArray.map((articleItem, i) => {
							return (
								<Styled.ArticleItem key={id + i}>
									<Styled.ArticleCategory>
										{header[i].content}
									</Styled.ArticleCategory>
									<Styled.ArticleValue>
										{articleItem.content}
									</Styled.ArticleValue>
								</Styled.ArticleItem>
							);
						})}
					</Styled.Article>
				);
			})}
		</Styled.ArticleList>
	);
};
